import { Component, Input } from '@angular/core';

/**
 * Para manipular a modal dentro de outro controller
 * Use um @ViewChild chamando o hash que a modal tem
 * dentro da view como atributo do objeto.
 *
 * Para monipular dentro da propria view, basta
 * chamar o nome do hash com o metodo
 *
 * // Modal
 *
 *  <app-modal #ModalName>
 *      <header class="modal-header">
 *          HEADER
 *      </header>
 *
 *      <section class="modal-content">
 *          BODY
 *      </section>
 *          <footer class="modal-action">
 *              // MANIPULANDO A MODAL DENTRO DA VIEW
 *              <button (click)="ModalName.hide()> Fechar </button>
 *          </footer>
 * </app-modal>
 *
 * // MANIPULANDO A MODAL DENTRO DO CONTROLLER
 * @ViewChild( ModalComponent ) ModalName: ModalComponent;
 *
 */

@Component({
    selector: 'app-modal',
    template: `
    <div class="modal-overlay fade" tabindex="-1"
        (click)="onContainerClicked($event)"
        [ngClass]="{'in': showModal}">
        <div class="modal-content"  [ngClass]="addClassesfather">
            <div class="modal">
                <ng-content select=".modal-header"></ng-content>
                <ng-content select=".modal-content"></ng-content>
                <ng-content select=".modal-action"></ng-content>
            </div>
        </div>
    </div>`,
})
export class ModalComponent {

    public showModal = false;
    public functionCallBackConfirmation: (param: any) => void;

    @Input() public addClassesfather: string = '';

    constructor() {
        //
    }

    // Show
    public show(): void {
        document.body.style.overflow = 'hidden';
        this.showModal = true;
    }

    // Hide
    public hide(): void {
        document.body.style.overflowY = 'auto';
        this.showModal = false;
    }

    // Modal Confirm callback
    public confirm( data?: any ) {
        // Abre a modal
        this.showModal = true;

        // Responta do confirm, exucuta a função de callback
        if ( typeof data === 'boolean' ) {
            this.functionCallBackConfirmation(data);
            this.showModal = false;
        } else if ( typeof data === 'function' ) {
            // Cria a função de callback
            this.functionCallBackConfirmation = data;
        }
    }

    public onContainerClicked(event: MouseEvent): void {
        /*if ((<HTMLElement>event.target).classList.contains('modal')) {
            this.hide();
        }*/
    }
}
